import { Toaster as HotToaster } from 'react-hot-toast';

/**
 * Centralised toaster. Modules import { toast } directly from `react-hot-toast`.
 * Mounted once at the app root so toasts can fire from anywhere.
 */
export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1F2937',
          color: '#F9FAFB',
          fontSize: '0.875rem',
        },
        success: {
          iconTheme: { primary: '#10B981', secondary: '#FFFFFF' },
        },
        error: {
          iconTheme: { primary: '#EF4444', secondary: '#FFFFFF' },
        },
      }}
    />
  );
}
